import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

// Plugin: disegna un anello grigio quando la somma è 0
const EmptyDoughnutBackground = {
  id: "emptyDoughnutBackground",
  beforeDatasetsDraw(chart, args, opts) {
    const dataset = chart.data?.datasets?.[0];
    if (!dataset) return;
    const sum = (dataset.data || []).reduce((a, b) => a + (Number(b) || 0), 0);
    if (sum > 0) return;

    const { ctx, chartArea } = chart;
    const meta = chart.getDatasetMeta(0);
    const arc = meta?.data?.[0];

    // Centro e raggi (fallback se meta è vuoto)
    const cx = arc?.x ?? (chartArea.left + chartArea.right) / 2;
    const cy = arc?.y ?? (chartArea.top + chartArea.bottom) / 2;
    const outer = arc?.outerRadius ?? Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top) / 2;
    const inner = arc?.innerRadius ?? outer * 0.75; // cutout 75%

    ctx.save();
    ctx.beginPath();
    ctx.arc(cx, cy, (inner + outer) / 2, 0, Math.PI * 2);
    ctx.lineWidth = outer - inner;
    ctx.strokeStyle = opts?.color || "#E5E7EB"; // grigio chiaro
    ctx.globalAlpha = opts?.opacity ?? 1;
    ctx.stroke();
    ctx.restore();
  },
};

ChartJS.register(EmptyDoughnutBackground);

export default function SupplyChainRiskDonut({
  data = [
    // { label: "ALTO", value: 45, color: "#F5A300" },
    // { label: "MEDIO", value: 30, color: "#BDBDBD" },
    // { label: "BASSO", value: 25, color: "#1F1F22" },
    { label: "ALTO", value: 45, color: "#DC2626" },
    { label: "MEDIO", value: 30, color: "#F5A300" },
    { label: "BASSO", value: 25, color: "#16A34A" },
  ],
  title = "STATO DELLA SUPPLY CHAIN",
  subtitle = "Indicatore di rischio aggregato",
}) {
  const chartData = {
    labels: data.map((d) => `${d.value}% ${d.label}`),
    datasets: [
      {
        data: data.map((d) => d.value),
        backgroundColor: data.map((d) => d.color),
        borderWidth: 0,
      },
    ],
  };

  const sum = data.reduce((s, d) => s + (d.value || 0), 0);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "75%",
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: sum > 0,             // niente tooltip quando è tutto a 0
        filter: (ctx) => (ctx.raw || 0) > 0, // ignora eventuali 0
      },
      emptyDoughnutBackground: {
        color: "#E5E7EB", // personalizzabile
        opacity: 1,
      },
    },
  };

  return (
    <div className="flex flex-col items-center">
      {/* Titoli */}
      <div className="mb-3 text-center">
        <div className="text-sm tracking-wide text-gray-400 font-semibold uppercase">
          {title}
        </div>
        <div className="text-sm font-semibold font  text-gray-700">{subtitle}</div>
      </div>

      {/* Grafico */}
      <div className="relative w-[220px] h-[220px]">
        <Doughnut data={chartData} options={options} />
        {/* Testo centrale */}
        <div className="absolute inset-0 flex flex-col items-center justify-center leading-snug">
          {data.map((d, i) => (
            <div key={i} style={{ color: d.color }} className="font-semibold text-base">
              {d.value}%
              <span className="uppercase font-normal text-sm ml-1">{d.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
